import * as routes from '../routes';

const flow = 'standardBorrower';

export default [
  {
    step: 'propertyState',
    previous: () => ({ flow: 'getRate', step: 'exitsLast24' }),
    nextStep: (state) => {
      if (state.property.stateUnsupported()) {
        return { flow, step: 'unsupportedUsState' };
      }
    },
    stepNumber: '2.1',
  },
  {
    step: 'entity',
    previous: () => ({ flow, step: 'propertyState' }),
    nextStep: (state) => {
      const requiresEntity = !state.borrower.hasEntity();

      if (requiresEntity) {
        return { flow, step: 'unsupportedBorrowerNoEntity' };
      }

      return { flow, step: 'yourEmail' };
    },
    stepNumber: '2.2',
  },
  {
    step: 'yourEmail',
    nextStep: (state) => {
      if (state.auth0IsDisabled() && state.user.emailExists()) {
        return { flow, step: 'signIn' };
      }

      return { flow, step: 'yourPhone' };
    },
    stepNumber: '2.3',
  },
  {
    step: 'yourPhone',
    nextStep: () => ({ flow, step: 'yourName' }),
    stepNumber: '2.4',
  },
  {
    step: 'yourName',
    nextStep: (state) => {
      if (state.auth0IsDisabled()) {
        return { flow, step: 'setPassword' };
      }
      return { flow, step: 'checkYourEmail' };
    },
    stepNumber: '2.5',
  },
  {
    step: 'checkYourEmail',
    previous: () => ({ flow, step: 'yourName' }),
    nextStep: () => ({ flow, step: 'leadPropertyAddress' }),
    stepNumber: '2.5.1',
  },
  {
    step: 'setPassword',
    previous: () => ({ flow, step: 'yourName' }),
    nextStep: () => ({ flow, step: 'leadPropertyAddress' }),
    stepNumber: '2.6',
  },
  {
    step: 'submit',
    nextStep: (state) => ({
      href: routes.editLoan(state.loan.getId()),
    }),
    stepNumber: '2.6',
  },
  {
    step: 'signIn',
    nextStep: () => ({ flow, step: 'leadPropertyAddress' }),
    previous: () => ({ flow, step: 'yourEmail' }),
    stepNumber: '2.3.1',
  },
  {
    step: 'leadPropertyAddress',
    previous: (state) => {
      if (state.auth0IsDisabled()) {
        return { flow, step: 'setPassword' };
      }

      return { flow, step: 'yourName' };
    },
    nextStep: (state) => {
      if (state.property.stateUnsupported()) {
        return { flow, step: 'unsupportedUsState' };
      }

      return { flow, step: 'submit' };
    },
    stepNumber: '2.3.2',
  },
  {
    step: 'unsupportedUsState',
    previous: (state) => {
      if (state.property.addressProvided()) {
        return { flow, step: 'leadPropertyAddress' };
      }

      return { flow, step: 'propertyState' };
    },
    guard: (state) => state.property.stateUnsupported(),
    stepNumber: '2.1.1',
    terminal: true,
  },
  {
    step: 'unsupportedBorrowerNoEntity',
    previous: () => ({ flow, step: 'entity' }),
    guard: (state) => !state.property.hasEntity(),
    terminal: true,
    stepNumber: '2.2.1',
  },
];
